export const BLOCKCHAIN_SUPPORT = 'blockchain_support';


// WEBPACK FOOTER //
// ./src/plugins/PluginTypes.js